<!--
* @Author: Yanxia Wan
* @Date: 2021-10-27
* @Description: 详情主体组件
-->
<template>
  <div class="ykc-detail-item-box">
    <el-form-item
      ref="ykcDetailItem"
      :label="label"
      :tagText="tagText"
      :class="formItemClass"
      :label-width="labelWidth">
      <slot></slot>
      <div class="tag" v-if="tagText" @click="onTagClick">
        {{ tagText }}
      </div>
      <div class="tag-icon">
        <div v-if="tagStatus === 1">
          <img class="icon" src="../../../../assets/images/tag-ok.png" />
          <span>正常</span>
        </div>
        <div v-if="tagStatus === 2">
          <img class="icon" src="../../../../assets/images/tag-no.png" />
          <span class="txt-no">有问题</span>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
  export default {
    name: 'YkcDetailItem',
    props: {
      label: String, // 标签文本
      labelWidth: String, // 12*字数+8
      formItemClass: String,
      isTag: {
        // 是否显示tag
        type: Boolean,
        default: false,
      },
      tagText: {
        // tag内容 默认为空
        type: String,
        default: '',
      },
      tagStatus: {
        // tag内容 默认为空
        type: Number,
        default: 0,
      },
    },
    methods: {
      onTagClick() {
        this.$emit('tagClick');
      },
    },
  };
</script>

<style lang="scss">
  @import './index.scss';
</style>
